import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const Home = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(rgba(123, 104, 238, 0.8), rgba(123, 104, 238, 0.8)), url("/hero-bg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          py: { xs: 10, md: 20 },
          textAlign: 'center',
        }}
      >
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography variant="h1" sx={{ mb: 3 }}>
              Whole Hog BBQ Since 1961
            </Typography>
            <Typography variant="h5" sx={{ mb: 4 }}>
              Locally Owned, Slow-Roasted Perfection
            </Typography>
          </motion.div>
          <Box
            component="img"
            src={require('../assets/images/logo.png')}
            alt="Weir Roastin' Logo"
            sx={{ width: '100%', maxWidth: 600, mt: 2, mb: 2 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              component={RouterLink}
              to="/contact"
              variant="contained"
              color="secondary"
              size="large"
              sx={{ mb: 4 }}
            >
              Book Now
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Features Section */}
      <Box sx={{ py: 8 }}>
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <Box sx={{ textAlign: 'center', p: 3 }}>
                  <Typography variant="h3" sx={{ mb: 2, color: 'primary.main' }}>
                    Tradition
                  </Typography>
                  <Typography>
                    Over 60 years of authentic whole hog BBQ experience, passed down through generations.
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={4}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <Box sx={{ textAlign: 'center', p: 3 }}>
                  <Typography variant="h3" sx={{ mb: 2, color: 'primary.main' }}>
                    Quality
                  </Typography>
                  <Typography>
                    Premium locally-sourced ingredients and time-honored cooking methods.
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={4}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <Box sx={{ textAlign: 'center', p: 3 }}>
                  <Typography variant="h3" sx={{ mb: 2, color: 'primary.main' }}>
                    Service
                  </Typography>
                  <Typography>
                    Professional catering services for events of any size, with exceptional attention to detail.
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h2" sx={{ mb: 3 }}>
              Ready to Experience Authentic BBQ?
            </Typography>
            <Button
              component={RouterLink}
              to="/contact"
              variant="contained"
              color="secondary"
              size="large"
            >
              Contact Us Today
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
